/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import * as S from "./styles";
import Rating from "@mui/material/Rating";
import CheckboxFilter from "../../CheckboxFilter";
import {
  Slider,
  FormControlLabel,
  Switch,
  FormControl,
  OutlinedInput,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import { Search } from "@material-ui/icons";
import CurrencyFormat from "react-currency-format";
import { useGlobal } from "../../../contexts/globalContext";
const HotelFilter = ({
  changeFilter,
  stays,
  searchState,
  loading,
  error,
  buscaAtual,
}) => {
  const [state, setState] = useState({ stars: 0, mapOrList: false });
  const [dailyPriceInicial, setDailyPriceInicial] = useState([0, 10000]);
  const [dailyPrice, setDailyPrice] = useState([0, 10000]);
  const [shortenCoinAlias, setShortenCoinAlias] = useState("Pts");

  const { user, signed } = useGlobal();

  // --- Handlers ---

  const onChangeFilters = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const onChangeStarsFilters = (stars) => {
    setState({ ...state, stars });
  };

  const changeMealPlanFilter = (mealPlanName, checked) => {
    const currentMealPlans = state.mealPlans || [];
    const updatedMealPlans = checked
      ? [...currentMealPlans, mealPlanName]
      : currentMealPlans.filter((mp) => mp !== mealPlanName);
    setState({ ...state, mealPlans: updatedMealPlans });
  };

  const getValuesByUser = (val) => {
    let value = signed
      ? val * user.catalog.catalogCurrencyConfig.conversionRate
      : val;
    return signed ? Math.ceil(Math.round(value)) : value;
  };

  // --- Effects ---

  useEffect(() => {
    const staysCopy = stays ? [...stays] : [];
    if (staysCopy.length === 0) {
      setDailyPriceInicial([0, 10000]);
      setDailyPrice([0, 10000]);
      return;
    }
    const prices = [...staysCopy].map((s) => s?.price?.amountAfterTax || 0);
    const minPrice = Math.min(...prices);
    const maxPrice = Math.max(...prices) || 10000;
    setDailyPriceInicial([minPrice, maxPrice]);
    setDailyPrice([minPrice, maxPrice]);
  }, [stays]);

  useEffect(() => {
    setState({ ...state, dailyPrice });
  }, [dailyPrice]);

  useEffect(() => {
    changeFilter(state);
  }, [state]);

  useEffect(() => {
    setShortenCoinAlias(
      user?.campaign?.campaignConfig?.shortenCoinAlias || "Pts"
    );
  }, [user?.campaign?.campaignConfig?.shortenCoinAlias]);

  // --- Dynamic regime alimentar (unique board type names from results) ---

  // Normalizes a meal plan name for deduplication:
  // trims, lowercases, collapses separators (-, _, spaces) into a single space.
  const normalizeMealPlan = (name) =>
    name.trim().toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ');

  const regimeAlimentarOptions = useMemo(() => {
    // Map from normalizedKey → { label: mostFrequentOriginalName, count, frequency }
    const groupMap = new Map();

    stays?.forEach((stay) => {
      const mealPlansInStay = new Set();
      stay.roomStays.roomTypes.forEach((roomType) => {
        roomType.roomRates.forEach((roomRate) => {
          const mp =
            roomRate.mealPlan ||
            roomRate.ratePlans?.mealPlanInfo?.mealPlanDescription;
          if (mp) mealPlansInStay.add(mp);
        });
      });

      mealPlansInStay.forEach((mp) => {
        const key = normalizeMealPlan(mp);
        const existing = groupMap.get(key);
        if (!existing) {
          groupMap.set(key, { label: mp, count: 1, labelFreq: { [mp]: 1 } });
        } else {
          existing.count += 1;
          existing.labelFreq[mp] = (existing.labelFreq[mp] || 0) + 1;
          // Use the most frequent original name as the display label
          const topLabel = Object.entries(existing.labelFreq).sort(
            (a, b) => b[1] - a[1]
          )[0][0];
          existing.label = topLabel;
        }
      });
    });

    return Array.from(groupMap.values())
      .sort((a, b) => a.label.localeCompare(b.label))
      .map(({ label, count }) => ({ mealPlanName: label, count }));
  }, [stays]);

  // --- Render ---

  return loading ? null : (
    <div>
      {!error && (
        <S.Wrapper>
          <S.FilterHeader>
            <S.FilterHeaderTitle>Filtros</S.FilterHeaderTitle>
          </S.FilterHeader>
          <div className="filter-group">
            <S.FilterTitle>Visualizar como:</S.FilterTitle>
            <FormControlLabel
              control={
                <Switch
                  checked={state.mapOrList}
                  onChange={() =>
                    setState({ ...state, mapOrList: !state.mapOrList })
                  }
                />
              }
              label={
                <S.ThinText>{state.mapOrList ? "Mapa" : "Lista"}</S.ThinText>
              }
            />
          </div>

          <div className="filter-group">
            <S.FilterTitle>Nome do hotel</S.FilterTitle>
            <FormControl variant="outlined" className="form-control">
              <OutlinedInput
                id="outlined-input-iconed"
                className="outlined-input-iconed"
                placeholder="Filtrar por nome de hotel..."
                type="text"
                name="hotelName"
                onChange={(e) => onChangeFilters(e)}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton color="default">
                      <Search size={24} />
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </div>

          <div className="filter-group">
            <S.FilterTitle>Estrelas maiores que:</S.FilterTitle>
            <Rating
              name="simple-controlled"
              value={state?.stars}
              precision={0.5}
              onChange={(event, starsValue) => onChangeStarsFilters(starsValue)}
            />
          </div>

          <div className="filter-group">
            <S.FilterTitle>Preço</S.FilterTitle>
            <S.ThinText>
              {signed && !user?.guest && !user?.campaign?.disablePointActivity ? (
                <span>
                  {getValuesByUser(dailyPrice[0])} {shortenCoinAlias} -{" "}
                  {getValuesByUser(dailyPrice[1])} {shortenCoinAlias}
                </span>
              ) : (
                <>
                  <CurrencyFormat
                    value={dailyPrice[0]}
                    displayType={"text"}
                    decimalSeparator=","
                    decimalScale={2}
                    prefix={"R$ "}
                  />{" "}
                  -{" "}
                  <CurrencyFormat
                    value={dailyPrice[1]}
                    displayType={"text"}
                    decimalSeparator=","
                    decimalScale={2}
                    prefix={"R$ "}
                  />
                </>
              )}
            </S.ThinText>
            <Slider
              value={dailyPrice}
              onChange={(event, newValue) => setDailyPrice(newValue)}
              valueLabelDisplay="off"
              aria-labelledby="range-slider"
              min={dailyPriceInicial[0]}
              max={dailyPriceInicial[1]}
            />
          </div>

          {regimeAlimentarOptions.length > 0 && (
            <div className="filter-group">
              <S.FilterTitle>Regime Alimentar</S.FilterTitle>
              {regimeAlimentarOptions.map((option) => (
                <CheckboxFilter
                  key={option.mealPlanName}
                  label={option.mealPlanName}
                  name={`mealPlan_${option.mealPlanName}`}
                  disabled={option.count === 0}
                  valueLabel={option.count}
                  onChange={(obj) =>
                    changeMealPlanFilter(option.mealPlanName, obj.checked)
                  }
                />
              ))}
            </div>
          )}
        </S.Wrapper>
      )}
    </div>
  );
};

export default HotelFilter;
